export const palette = {
	brandBlue: "#0066A4", 
	brandOrange: "#EE8422", 
	gray: "#4F585A", 
	lightGray: "#9B9B9B", 
	white: "#ffffff", 
    black: "#000000",
	red: '#ED462B'
} 
